import { type ScenarioGraph } from 'types/api/scenarios/scenario'

export enum ScenarioPreviewSentinels {
  ServiceId = 'SERVICE_ID_SENTINEL',
  Dependency = 'DEPENDENCY_ID_SENTINEL',
  RandomDNS = 'RANDOM_DNS_SERVER_SENTINEL',
  RandomZone = 'RANDOM_ZONE_SENTINEL',
  StatusCheck = 'STATUS_CHECK_ID_SENTINEL'
}

export enum ScenarioPreviewMetadataKey {
  Dependency = 'Dependency',
  Service = 'Service'
}

export interface ScenarioPreview {
  graph: ScenarioGraph
  metadata: ScenarioPreviewMetadataKey[]
}
